import { render, staticRenderFns } from "./advertisingPoliciesTab.vue?vue&type=template&id=dbafc582&scoped=true&"
import script from "./advertisingPoliciesTab.vue?vue&type=script&lang=js&"
export * from "./advertisingPoliciesTab.vue?vue&type=script&lang=js&"
import style0 from "./advertisingPoliciesTab.vue?vue&type=style&index=0&id=dbafc582&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbafc582",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabItem,VTabs,VTabsItems,VTabsSlider})
